function Layout({children}){
    return(
        <div>
            <div className="container mx-auto">
            {children}
            </div>
        </div>
    )
  }
  export default Layout;

//   background-image: linear-gradient(to bottom right, #C9E265, #086C8B);